"use strict";
/* globals module */
/**
 * @module templatingClient
 * @description  Templating Client provides an easy way to consume  Templating REST API end-points. In order to obtain a needed routes `templatingClient` uses `templatingRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var TemplatingClient = /** @class */ (function () {
    function TemplatingClient(templatingRoute, templatingBatchClient, apiClient) {
        this.templatingRoute = templatingRoute;
        this.templatingBatchClient = templatingBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(TemplatingClient.prototype, "routeDefinition", {
        get: function () {
            return this.templatingRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TemplatingClient.prototype, "batch", {
        get: function () {
            return this.templatingBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of template resources matching the given criteria.
     * @method
     * @param options Query resource options.
     * @returns A promise that is resolved once the find action has been performed.
     * @example templatingClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    TemplatingClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified template resource.
     * @method
     * @param id Template id which uniquely identifies Template resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example templatingClient.get('<template-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    TemplatingClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.templatingRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create template action has been performed; this action creates a new template resource.
     * @method
     * @param data An Template object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create template action has been performed.
     * @example templatingClient.create({  content : '<content>',  templateId : '<template-id>' })
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    TemplatingClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update template action has been performed; this action updates a template resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicTemplatingRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(template);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An template object used to update specified Template resource.
     * @returns A promise that is resolved once the update template action has been performed.
     * @example // template is a resource previously fetched using get action.
                    template.content = '<new-content>';
                    templatingClient.update(template)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    TemplatingClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a template resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicTemplatingRouteDefiniton` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(template);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An template object used to delete specified Template resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // template is a resource previously fetched using get action.
                    templatingClient.remove(template)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    TemplatingClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    TemplatingClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.TemplatingRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.TemplatingBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.TemplatingRoute !== "undefined" && _1.TemplatingRoute) === "function" ? _a : Object, typeof (_b = typeof _1.TemplatingBatchClient !== "undefined" && _1.TemplatingBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], TemplatingClient);
    return TemplatingClient;
}());
exports.TemplatingClient = TemplatingClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 
